import dataPeriTarDaptAsa from "../../../../src/data/periprocedureel-beleid-tar-dapt-asa-dip.json";
import BasicCollapse from "../../../../src/components/chart/interaction/basic-collapse/Chart.js";
import * as React from 'react';
export default {
  dataPeriTarDaptAsa,
  BasicCollapse,
  React
};